import {
  Confirmation,
  ConfirmDialog,
  CustomButton,
  sidebarPopupConfig,
  SvgHorizontalSplitter,
  Tooltip,
  urlPatternMatcher,
} from '@ui-kit'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { NAMESPACES } from '../utils/constants'
import { isEmpty } from 'lodash'

const ManageQueueButton = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false)
  const [dialogInfo, setDialogInfo] = useState<{
    url: string[]
    message: string
  } | null>(null)

  const handleLinkClick = (e: React.MouseEvent, url: string) => {
    e.preventDefault()

    if (dialogInfo) {
      setConfirmDialogOpen(true)
    } else {
      navigate(url)
    }
  }

  useEffect(() => {
    if (location.pathname) {
      setDialogInfo(urlPatternMatcher(location.pathname, sidebarPopupConfig))
    }
  }, [location.pathname])

  return (
    <div className="w-full flex flex-col justify-center  bg-tertiary-100 p-2">
      <SvgHorizontalSplitter className="mb-4" />
      <Link
        to={'/manage-queue'}
        data-qa-id={'manage-queue-btn-config'}
        onClick={(e) => handleLinkClick(e, '/manage-queue')}
      >
        <Tooltip content={NAMESPACES.MANAGE_QUEUES_LABEL} position="right">
          <CustomButton
            className="min-w-52 h-8"
            color="primary"
            isFilled={false}
            horizontalPaddingClasses="px-3"
          >
            <span className="text-xs font-light">
              {NAMESPACES.MANAGE_QUEUES_LABEL}
            </span>
          </CustomButton>
        </Tooltip>
      </Link>

      <ConfirmDialog
        showCloseButtton={false}
        open={confirmDialogOpen && !isEmpty(dialogInfo)}
        confirmButtonText={Confirmation.YES}
        cancelButtonText={Confirmation.NO}
        message={dialogInfo?.message ?? ''}
        onConfirm={() => {
          navigate('/manage-queue')
          setConfirmDialogOpen(false)
        }}
        onCancel={() => {
          setConfirmDialogOpen(false)
        }}
      />
    </div>
  )
}

export default ManageQueueButton
